export enum InputFieldNames {
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  EMAIL = 'email',
  PHONE = 'phone',
  BUSINESS_NAME = 'businessName',
  IS_BUSINESS = 'isBusiness',
}

export interface IFormData {
  [InputFieldNames.FIRST_NAME]: string
  [InputFieldNames.LAST_NAME]: string
  [InputFieldNames.EMAIL]: string
  [InputFieldNames.PHONE]: string
  [InputFieldNames.BUSINESS_NAME]: string
  [InputFieldNames.IS_BUSINESS]: boolean
}
